import React, { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

const StepPayment = ({ total, submitting, onConfirm, onBack }) => {
  const { t } = useLanguage();
  const [method, setMethod] = useState("CARD");

  const METHODS = [
    { value: "CARD", label: t("payment.card") },
    { value: "PAYPAL", label: t("payment.paypal") },
    { value: "CASH_ON_DELIVERY", label: t("payment.cod") },
  ];

  return (
    <div className="step">
      <h3>{t("payment.title")}</h3>
      <div className="payment-options">
        {METHODS.map((m) => (
          <div
            key={m.value}
            className={`payment-option-card ${method === m.value ? "selected" : ""}`}
            onClick={() => setMethod(m.value)}
          >
            <span className={`hex-marker ${method === m.value ? "" : "moss"}`} />
            {m.label}
          </div>
        ))}
      </div>

      <p style={{ marginTop: "1rem" }}>
        {t("payment.totalDue")} <strong>${total.toFixed(2)}</strong>
      </p>

      <div className="step-buttons">
        <button onClick={onBack} disabled={submitting}>
          {t("payment.back")}
        </button>
        <button onClick={() => onConfirm(method)} disabled={submitting}>
          {submitting
            ? t("payment.placing")
            : t("payment.placeOrder", { amount: `$${total.toFixed(2)}` })}
        </button>
      </div>
    </div>
  );
};

export default StepPayment;
